import { z } from 'zod';

export interface FlowApi {
  id: string;
  name: string;
  description?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface Flow {
  id: string;
  name: string;
  description?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface NewFlow {
  name: string;
  description?: string | null;
  logisticOperatorId: string;
}

export interface UpdateFlow {
  id: string;
  name: string;
  description?: string | null;
  logisticOperatorId: string;
}

export interface FlowFilters {
  name?: string;
  logisticOperatorId?: string;
}

export const flowSchema = z.object({
  name: z
    .string()
    .min(1, 'El nombre es requerido')
    .max(200, 'El nombre no puede exceder 200 caracteres'),
  description: z
    .string()
    .max(2000, 'La descripción no puede exceder 2000 caracteres')
    .optional()
    .nullable(),
});

export const updateFlowSchema = flowSchema.extend({
  id: z.string().uuid('El ID debe ser un UUID válido'),
  logisticOperatorId: z
    .string()
    .uuid('El ID del operador logístico debe ser un UUID válido'),
});

export type FlowSchema = z.infer<typeof flowSchema>;
export type UpdateFlowSchema = z.infer<typeof updateFlowSchema>;

export const defaultFlowValues: FlowSchema = {
  name: '',
  description: null,
};
